import { render } from "./ShowRalat.vue?vue&type=template&id=6f3db822"
import script from "./ShowRalat.vue?vue&type=script&lang=js"
export * from "./ShowRalat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__